import { Tooltip } from '@byecode/ui'
import type { IconStyle, IconTabs, Position } from '@lighthouse/core'
import type { IconDecoration } from '@lighthouse/shared'
import { IconPicker } from '@lighthouse/shared'
import type { PopoverBaseProps } from '@mantine/core'
import type { UploadyProps } from '@rpldy/shared-ui'
import React, { forwardRef } from 'react'

type IconControlProps = {
    value?: string
    clearable?: boolean
    style?: React.CSSProperties
    size?: number
    disabled?: boolean
    allowIconTypes?: IconTabs[]
    uploadParams?: UploadyProps
    position?: PopoverBaseProps['position']
    onGetFullUrl?: (url: string) => string
    onChange?: (v: string) => void
}

export const IconControl = forwardRef<HTMLInputElement, IconControlProps>(
    ({ value = '', clearable = true, size, disabled, allowIconTypes, uploadParams, position, onGetFullUrl, onChange }, ref) => {
        return (
            <Tooltip disabled={disabled} title={value ? '更换图标' : '添加图标'}>
                <IconPicker
                    size={size}
                    disabled={disabled}
                    position={position}
                    clearable={clearable}
                    allowIconTypes={allowIconTypes}
                    uploadParams={uploadParams}
                    onGetFullUrl={onGetFullUrl}
                    ref={ref}
                    value={{ type: 'icon', value }}
                    onChange={val => onChange?.(val?.value ?? '')}
                />
            </Tooltip>
        )
    }
)

interface IconControlV2Props {
    value?: IconDecoration
    clearable?: boolean
    size?: number
    disabled?: boolean
    allowIconTypes?: IconTabs[]
    uploadParams: UploadyProps
    onChange?: (v?: IconDecoration) => void
    onGetFullUrl?: (url: string) => string
}

export const IconControlV2 = forwardRef<HTMLInputElement, IconControlV2Props>(({ clearable = true, ...rest }, ref) => {
    return (
        <Tooltip disabled={rest.disabled} title={rest.value ? '更换图标' : '添加图标'}>
            <IconPicker clearable={clearable} ref={ref} {...rest} />
        </Tooltip>
    )
})
